[
  {
    "id": "wrack",
    "title": "Wrack 'n Crack",
    "summary": "Twin-stick arena shooter. 2069. OmniGrunt's favorite lethal game show.",
    "status": "wip",
    "visibility": "public",
    "year": 2026,
    "tags": ["game", "godot", "pc"],
    "icon": "wrack",
    "appId": "wrack"
  }
]
